/**
 * Custom logger utility
 * Automatically disables console.log in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    // Keep error logs in production for debugging
    console.error(...args);
  },
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

// Alternative: Override global console (use with caution)
export const disableConsoleInProduction = () => {
  if (!isDevelopment) {
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    // Keep console.warn and console.error for important messages
  }
};

export default logger;

